import React, { useState, useEffect } from "react";
import DynamicTable from "@atlaskit/dynamic-table";
import { useDispatch, useSelector } from "react-redux";
import { httpHeaderTableHead } from "../../../common/constants/core/integration.constants";
import uuid from "react-uuid";
import AddIcon from "@atlaskit/icon/core/add";
import DeleteIcon from "@atlaskit/icon/core/delete";
import Button from "@atlaskit/button/new";
import CellTextField from "../../../common/components/CellTextField";
import { modifySelectedCred } from "../../../redux/actions/credActions";
import { clone } from "../../../common/utils/helper";

const AuthHeaders = () => {
  const dispatch = useDispatch();
  const [rows, setRows] = useState([]);
  const selectedCred = useSelector((state) => state.auth.selectedCred);

  useEffect(() => {
    if (selectedCred?.data?.headers) {
      setRows(getRows());
    } else if (selectedCred && !selectedCred.data) {
      selectedCred.data = {
        headers: [],
      };
      const credentials = clone(selectedCred);
      dispatch(modifySelectedCred(credentials));
    } else {
      setRows([]);
    }
  }, [selectedCred]);

  const createRow = (item, index) => ({
    cells: [
      {
        content: (
          <CellTextField
            inputValue={item.key}
            index={index}
            onChange={onChangeHeader}
            type="KEY"
          />
        ),
        key: uuid(),
      },
      {
        content: (
          <CellTextField
            inputValue={item.value}
            index={index}
            onChange={onChangeHeader}
            type="VALUE"
          />
        ),
        key: uuid(),
      },
      {
        content: getButton(index),
        key: uuid(),
      },
    ],
  });
  const getButton = (index) => {
    return (
      <Button
        onClick={() => onRemoveHeader(index)}
        iconBefore={DeleteIcon}
        aria-label="Remove Header"
      />
    );
  };
  const onChangeHeader = (value, index, type) => {
    switch (type) {
      case "KEY":
        selectedCred.data.headers[index].key = value;
        break;
      case "VALUE":
        selectedCred.data.headers[index].value = value;
        break;
      default:
        break;
    }
    dispatch(modifySelectedCred(selectedCred));
  };

  const getRows = () => {
    if (selectedCred?.data?.headers && Array.isArray(selectedCred?.data?.headers)) {
      return selectedCred?.data?.headers.map((h, i) => {
        return createRow(h, i);
      });
    }
    return [];
  };
  const onAddHeader = () => {
    selectedCred?.data?.headers
      ? selectedCred?.data?.headers.push({ key: "", value: "" })
      : (selectedCred.data.headers = [{ key: "", value: "" }]);
    setRows(getRows());
    dispatch(modifySelectedCred(selectedCred));
  };
  const onRemoveHeader = (index) => {
    if (index > -1) {
      selectedCred.data.headers.splice(index, 1);
      setRows(getRows());
      dispatch(modifySelectedCred(selectedCred));
    }
  };

  return (
    <>
      <>
        <Button
          onClick={onAddHeader}
          iconBefore={AddIcon}
          aria-label="Add Header"
        />
        &nbsp;&nbsp;Add Header
      </>
      <DynamicTable head={httpHeaderTableHead} rows={rows ? rows : []} />
    </>
  );
};

export default AuthHeaders;
